export function isDiagnosticsEnabled() {
  return window.debug === true;
}
